import { useComplexState } from 'hook/helper.hook';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { AUTO_LOAN_VERTICAL } from 'types/marketplaceTiles.constants';
import { getAutoloanClickTrackingAttributes } from 'helpers/tracking.helpers';

export const useCommonAutoLoanHook = ({ eventHandler }) => {
  const [commonStates, setCommonStates] = useComplexState({
    showModal: false,
  });

  const displayModal = ({ moduleName }) => {
    setCommonStates({
      showModal: true,
    });

    const trackingAttributes = getAutoloanClickTrackingAttributes({
      clickType: 'Search & Filter Button',
      vertical: AUTO_LOAN_VERTICAL,
      moduleName,
    });
    eventHandler(CLICK, trackingAttributes);
  };

  const hideModal = ({ moduleName }) => {
    setCommonStates({
      showModal: false,
    });

    const trackingAttributes = getAutoloanClickTrackingAttributes({
      clickType: 'Cancel Search Criteria',
      vertical: AUTO_LOAN_VERTICAL,
      moduleName,
    });
    eventHandler(CLICK, trackingAttributes);
  };

  return {
    commonStates,
    displayModal,
    hideModal,
    setCommonStates,
  };
};
